import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { map, Observable } from 'rxjs';
import { base64ToGuid, guidToBase64 } from '@core/utils/guid-encode';
import { AsyncPipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SyrfDialogService } from '@shared/dialog/syrf-dialog.service';
import { SyrfDialogLayoutComponent } from '@shared/dialog/syrf-dialog-layout.component';

/** The dialog heading (the page heading the decoder always showed). */
export const GUID_DECODE_DIALOG_TITLE = 'Guid - Base64 Decoder/Encoder';

/** Admin tool: converts a GUID to and from its base64 form as you type. Closes with `undefined` (Escape, backdrop). */
@Component({
  selector: 'app-guid-decode',
  templateUrl: './guid-decode.component.html',
  styleUrls: ['./guid-decode.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SyrfDialogLayoutComponent,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
})
export class GuidDecodeComponent {
  /** Opens the decoder (the nav's admin menu), sized as it always was. */
  static open(dialog: SyrfDialogService) {
    return dialog.open(GuidDecodeComponent, {
      mode: 'adaptive',
      title: GUID_DECODE_DIALOG_TITLE,
      width: '500px',
    });
  }

  valueControl: FormControl = new FormControl();
  guidValue$: Observable<string> = this.valueControl.valueChanges.pipe(
    map((value: string) => {
      try {
        return base64ToGuid(value);
      } catch (e) {
        return e.message;
      }
    })
  );
  base64Value$: Observable<string> = this.valueControl.valueChanges.pipe(
    map((value: string) => {
      try {
        return guidToBase64(value);
      } catch (e) {
        return e.message;
      }
    })
  );
}
